import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ParticipantsListScreenComponent} from "./screen/participants-list-screen.component";
import {SharedModule} from "../../shared/shared.module";
import {StoreModule} from "@ngrx/store";
import {reducer} from "./core/participants-list.reducer";
import {EffectsModule} from "@ngrx/effects";
import {ParticipantsListEffects} from "./core/participants-list.effects";
import {MaterialModule} from "../../shared/material-module";
import {
  ConfirmParticipantInformationComponent
} from "./pages/confirm-participant-information/confirm-participant-information.component";
import {RelationshipDetailsComponent} from "./pages/relationship-details/relationship-details.component";
import {
  ParticipantAdditionalDetailsComponent
} from "./pages/participant-additional-details/participant-additional-details.component";
import {
  ParticipantsListTableComponent
} from './pages/components/participants-list-table/participants-list-table.component';


@NgModule({
  declarations: [
    ParticipantsListScreenComponent,
    ConfirmParticipantInformationComponent,
    RelationshipDetailsComponent,
    ParticipantAdditionalDetailsComponent,
    ParticipantsListTableComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    StoreModule.forFeature('ss-cord.participants-list', reducer),
    EffectsModule.forFeature(
      [ParticipantsListEffects]
    ),
    MaterialModule,
  ]
})
export class ParticipantsListModule {
}
